
import BaseView from "@core/View.js";
import Alert from "@util/alert.js";
import {$util} from "@util/util.js";
export default class ServiceListWapView extends BaseView{
    constructor(model){
        super(model);
        this._model._view = this;
        this._parentEl = this._model._parent._view._serverBoxEl;
        this._el = null;
    }

    getItems(category){
        //  style="${item.stock.salesNumber > 0 ? '' : 'pointer-events: none;'}"
        let html = ''
        category.serviceGoodsList.map((item,index) => {
            // console.log('item',item);
            html += ` <li class="clearfix ${item.cateChecked ? "active" :  '' }" style="display:flex;" data-disabled="1" tag="getItemChecked" data-goodscode="${item.code}">
                <span style="white-space: nowrap;text-overflow: ellipsis;overflow: hidden;word-break: break-all;display: inline-block;width: 2rem;">${item.name}</span>
                <span class="fr">¥${item.price.P_C.C_2.P_0.DV.V}</span>
                <i style='display:${item.message.toString().trim() == "" ? "none" :"block"}' >${item.message}</i>
                <span class="disshow" style="position:absolute;top:0;right:-0.5rem;display:none;">已失效</span>
            </li>`;
        })
      return html
    }
    getInitData() {
        //初始化选择状态为未选中
        this._model._serviceList.map((i,d)=> {
            i.cateChecked = false;
        })

        //主品上有的服务商品状态改为选中
        if(this._model._parent._data.services && this._model._parent._data.services.length>0) {
            // 处理数据
            this._model._parent._service._data.map((item,index)=>{
                this._model._serviceList.map((i,d)=> {
                   i.serviceGoodsList.map((ind,data)=>{                       
                    if(item.id == ind.code) {
                        ind.cateChecked = true;
                    } 
                   })
                })
            })
        }  
    }
    getCategories(){
        let html = ``;
        this._model._serviceList.map((item,index) => {
            // console.log(item,'item')
            html += `<h4>${item.category}<i class="iconfont icon-service-info"></i></h4>
            <ul style="width:2.62rem">
            ${this.getItems(item)}
            </ul>`;
        })
        html += `</ul>`;

      return html
    }
    getProductInfo() {
        let html = ``;
        // console.log('wap服务价格',this._model._parent);
        html += `<dt>
                    <img class="service_goods_img" src="${this._model._parent._img}" alt="">
                </dt>
                <dd>
                    <p class="price"><span class="mark">¥</span>${this._model._parent._price.indexOf('¥')>-1 ? this._model._parent._price.split('¥')[1].indexOf('.')>-1 ? this._model._parent._price.split('¥')[1].split('.')[0]: this._model._parent._price.split('¥')[1] : this._model._parent._price.indexOf('.')>-1 ? this._model._parent._price.split('.')[0] : this._model._parent._price}<span class="floating">${this._model._parent._price.indexOf('.')>-1 ? '.'+this._model._parent._price.split('.')[1] : ''}</span></p>
                    <p class="number">商品编号：${this._model._parent._data.id}</p>
                </dd>`;
        return html;
    }
    getServiceInfoItem(item) {
        let html = '';
        item.serviceGoodsList.map((data,index)=> {
            html+=`<div class="item">
                <div class="item_title">
                    <span class="name" style="white-space: nowrap;text-overflow: ellipsis;overflow: hidden;word-break: break-all;display: inline-block;width: 2rem;">${data.name}</span>
                    <span class="price">¥${data.price.P_C.C_2.P_0.DV.V}</span>
                    <i class="iconfont icon-arrow-down" tag="icon-arrow-down" data-code="${data.code}"></i>
                </div>
                <div class="item_desc item_${data.code}"></div>
            </div>`;
        })
        return html;
    }
    getServiceInfo() {
        let html = '';
        this._model._serviceList.map((item,index) => {
            html += `
                <div class="box_item">
                <h3>${item.category}</h3>
                <div class="info_list">
                ${this.getServiceInfoItem(item)}
                </div>
                </div>`;
        })
        
        return html;
    }

    render(){
        this.getInitData();
        let str = "";
        str = `${this.getProductInfo()}`;
        $(this._parentEl.find("dl")).html($(str));
        let html = "";
        html += ` <h3>保障服务</h3>       
            ${this.getCategories()}
        `;
        $(this._parentEl.find("div.service_type_box")).html($(html));
        $(this._parentEl.find("img.service_goods_img")).attr("src",this._model._parent._data.imgUrl);
        // 渲染服务说明
        let info = `${this.getServiceInfo()}`;
        $("div.service_info_wrapper .info_box").html($(info));
        this._el = $(".service_wrapper");
        this._sl = $('.service_info_wrapper');
        let count = $('li[tag="getItemChecked"].active').length
        $('.option_common_bottom p span').html(count);
        // 每次render都清空选择了几件服务
        // $('service_wrapper .option_common_bottom p span').html('0')
        
        this.regEvent();
        
    }
    renderInfo(data) {
        let html = '';
        for(var key in data) {
            html += `${data[key]}`;
            $(`.service_info_wrapper .info_box .box_item .item .item_${key}`).html(html.replace(/&quot;&quot;/g, '')).show();
        }
    }
    regEvent() {
        let that = this;
        // 点击选择服务叉号, 隐藏弹窗icon-close
        this._el.off("click", "i[tag='chooseService']").on("click", "i[tag='chooseService']", function () {
            $('div.service_wrapper').css('display','none');
            $util.toggleBodyScroller(false);
        })
        // 点击选中服务
        this._el.off("click", "li[tag='getItemChecked']").on("click", "li[tag='getItemChecked']", function () {
            // 移除当前服务其它条数的选中状态 , 同一大类下是单选, 多个大类是多选
            $(this).siblings().removeClass('active');
            let disclick = $(this).attr('data-disabled');
            if(disclick == 0) {
                if($(this).attr('class').indexOf('active')>-1) {
                    $(this).addClass('disabled');
                    $(this).children('.disshow').hide();
                } else if($(this).attr('class').indexOf('active')==-1) {
                    $(this).removeClass('disabled');
                    $(this).children('.disshow').show();
                }
                $(this).toggleClass('active');
            } else if(disclick == 1) {
                $(this).toggleClass('active');
            }
            
            let count = $('li[tag="getItemChecked"].active').length
            $('.option_common_bottom p span').html(count);
        })
        // 点击感叹号, 弹出服务说明
        this._el.off("click", ".icon-service-info']").on("click", ".icon-service-info", function () {
            $('.service_info_wrapper').show();
        })
        // 点击服务说明的上下箭头
        this._sl.off("click", ".info_box .box_item .item .item_title i[tag=icon-arrow-down]").on("click", ".info_box .box_item .item .item_title i[tag=icon-arrow-down]", function () {
            let code = $(this).attr('data-code');
            if($(this).hasClass('icon-arrow-down')) {
                $(this).removeClass('icon-arrow-down').addClass('icon-arrow-up');
                // 请求图片数据
                that._model.getServiceListInfo(code).then((x)=>{
                    that._model.initInfo(code); 
                    that.renderInfo(that._model._infoList[0]);
                });
            } else if($(this).hasClass('icon-arrow-up')){
                $(this).removeClass('icon-arrow-up').addClass('icon-arrow-down');
                // 隐藏请求数据
                $('.service_info_wrapper .info_box .box_item .item .item_'+code).hide();
            }
        })
        // 点击服务说明的箭头,隐藏弹框
        this._sl.off("click", ".header .icon-arrow-lift").on("click", ".header .icon-arrow-lift", function () {
           $('.service_info_wrapper').hide();
        })

        // 点击确定
        this._el.off("click", ".option_common_bottom .service-select-confirm").on("click", ".option_common_bottom .service-select-confirm", function () {
            var iconFlag = 1;
            // 判断选择的是否有失效的服务
            $("li[tag='getItemChecked'].active").each((index,item)=> {
                if($(item).attr('data-disabled') == '0') {
                    iconFlag = 0;
                    Alert.showTip('请取消失效商品');
                    // 包含失效商品
                    return false;
                }
            })
            if(iconFlag == 1) {
                var selectedItem =  $("li[tag='getItemChecked'].active");
                var codes ="";
                selectedItem.each(function(index,li){
                    codes += $(li).data("goodscode")+"@";
                  }); 
                codes = codes.substr(0,codes.length-1);
                that._model._parent.modifyItemFromCart({opsType:3,content:codes}).then(()=>{
                    // 判断如果是0的话就手动隐藏服务的样
                    // 解决问题是: 不选择服务, 不会更新样式,始终保持着最后一条更新的服务, 刷新页面就会更新
                    if(selectedItem.length == '0') {
                        $(that._model._parent._view._extraBoxEl.find('div.service')).hide();
                        $(that._model._parent._view._el).find('p.service_box button span').html('选择服务');
                    } else if(selectedItem.length > 0) {
                        // 如果选择服务就将选择服务设置为修改服务
                        $(that._model._parent._view._el).find('p.service_box button span').html('修改服务');
                    }
                });
                $('div.service_wrapper').css('display','none');
                $util.toggleBodyScroller(false);
            }
        })

    }
}

